<template>
   <span
      v-for="tag in shownTags"
      :key="tag.id"
      class="badge rounded-pill me-1"
      :class="{ 'tag-short': max > 0 }"
      :style="{ background: tag.color }"
      :title="tag.name"
   >{{ tag.name }}</span>

   <!-- The rest as "+2" (hover to see their names) -->
   <span
      v-if="hiddenTags.length"
      class="badge rounded-pill bg-secondary"
      :title="hiddenTags.map((tag) => tag.name).join(', ')"
   >+{{ hiddenTags.length }}</span>
</template>

<script>
// A record's tags as coloured labels:  <TagBadges :tags="record.tags" />
// Table cell with a limit:              <TagBadges :tags="record.tags" :max="2" />  → "VIP  Urgent  +3"
export default {
   name: "TagBadges",
   props: {
      tags: { type: Array, default: () => [] }, // [{ id, name, color }]
      max: { type: Number, default: 0 },        // 0 = show every tag
   },
   computed: {
      shownTags() {
         return this.max > 0 ? this.tags.slice(0, this.max) : this.tags;
      },
      hiddenTags() {
         return this.max > 0 ? this.tags.slice(this.max) : [];
      },
   },
};
</script>

<style scoped>
/* Table cell (with :max): long names end in "…", hover shows the full name */
.tag-short {
   max-width: 80px;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   vertical-align: middle;
}
</style>